import { Language } from '../config/translations';

// Language detection
export function detectLanguage(): Language {
  const browserLang = navigator.language.toLowerCase();
  if (browserLang.startsWith('sv')) return 'sv';
  if (browserLang.startsWith('es')) return 'es';
  if (browserLang.startsWith('de')) return 'de';
  return 'en';
}

// Static image constants
export const RESTAURANT_IMG = "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?q=80&w=2070&auto=format&fit=crop";
export const MAP_IMG = "/map-hero.jpg"; // Place the uploaded image in public as map-hero.jpg

export const FEATURE_IMAGES = [
  {
    src: "/map-hero.jpg", // Map background image for Restaurant Discovery (was waiter image)
    alt: "Interactive map showing restaurant locations"
  },
  {
    src: "https://images.pexels.com/photos/13107876/pexels-photo-13107876.jpeg?auto=compress&w=400&h=400&fit=crop",
    alt: "Family with children eating at a restaurant"
  },
  {
    src: "https://images.pexels.com/photos/9800009/pexels-photo-9800009.jpeg?auto=compress&w=400&h=400&fit=crop",
    alt: "EV car charging at a station"
  }
];